import { setupI18n } from "@lingui/core";
import catalogEn from './locales/en/messages.js';
import catalogEs from './locales/es/messages.js';
import catalogPt from './locales/pt/messages.js';
import catalogDe from './locales/de/messages.js';

const AVAILABLE_LANGUAGES = ["en", "es", "pt", "de"];

let userLanguage = localStorage.getItem('lang');
if (!userLanguage || AVAILABLE_LANGUAGES.includes(userLanguage) === false) {
  let defaultLanguage = "en";
  if (navigator.languages) {
    const browserLanguage = navigator.languages[0].split("-")[0];
    if (AVAILABLE_LANGUAGES.includes(browserLanguage)) {
      defaultLanguage = browserLanguage;
    }
  }

  localStorage.setItem('lang', defaultLanguage);
  userLanguage = defaultLanguage;
}

const i18n = setupI18n();
i18n.load({
  en: catalogEn,
  es: catalogEs,
  pt: catalogPt,
  de: catalogDe,
});
i18n.activate(userLanguage);
export default i18n;
